module.exports = __webpack_public_path__ + "media/images/icon/icons8-Info Popup-17672b89694a453c4076d99a9924f31c.png";